module.exports = __webpack_public_path__ + "media/about-us.718753bc.mp4";